<div class="dialog-content-wrapper" style="margin: -24px;">
  <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">Maintenance In Progress</span>
          </mat-toolbar-row>


  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
    <div>{{data.MaintenanceMessage}}</div>
  </div>
  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
      <button mat-raised-button color="accent" aria-label="SAVE" 
      *ngIf="maintainanceActivity.length > 0 && maintainanceActivity[0]['MaintainanceActivity'] == '1'"
      (click)="checkMaintainance();" fxFlex="47">
        Refresh
      </button>
      <button mat-raised-button color="accent" aria-label="SAVE" (click)="closeMaintainance();" fxFlex="47"
      *ngIf="maintainanceActivity.length > 0 && maintainanceActivity[0]['MaintainanceActivity'] == '0'"
      >
        Close
      </button>
      
  </div>
</div>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/maintainance/maintainance.component.html